import React from 'react';
import PropTypes from 'prop-types';

const Footer = ({ version, provider }) => (
  <footer className="footer">
    <span className="footer-version">{version}</span>
    <span className="footer-provider">{provider}</span>
  </footer>
);

Footer.propTypes = {
  version: PropTypes.string.isRequired,
  provider: PropTypes.string.isRequired
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx